<template>
  <div class="p-20">
    <van-form label-width="110" ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'ssdwmc'" v-model="formData.ssdwmc" :disabled="isDisabled('ssdwmc')" :required="isRequired('ssdwmc')" name="ssdwmc" :rules="getRules('ssdwmc')" maxlength="50" autosize label="实施单位名称" placeholder="请输入实施单位名称" input-align="right"/>
        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')" :value="formData.ssxm" :rules="getRules('ssxm')" label="所属项目" placeholder="请选择项目">
          <template #input>
            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm" placeholder="请选择项目"/>
            <van-popup v-model="ssxm.show" position="bottom">
              <van-nav-bar title="选择项目" left-text="取消" right-text="确定" @click-left="ssxm.show = false" @click-right="popupSubmitSsxm('ssxm',{label:'projectName',value:'projectId'})"/>
              <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'projectName')" clearable shape="round"/>
              <van-picker :duration="0" ref="ssxm" value-key="projectName" :columns="ssxm.filteredData" @cancel="ssxm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'xmfzr'" :value.prop="formData.xmfzr" :required="isRequired('xmfzr')" name="flowName" label="项目负责人" placeholder="项目负责人" input-align="right" :rules="getRules('xmfzr')">
          <template #input>
            <view-item @click.native="isShowPopup(deptUserTreeAll,'xmfzr')" :value="formData.xmfzr[0]?.name" placeholder="请选择项目负责人"/>
            <van-popup position="bottom" v-model="deptUserTreeAll.show">
              <van-nav-bar title="选择项目负责人" left-text="取消" right-text="确定" @click-left="deptUserTreeAll.show = false" @click-right="handlePopupSubmit"/>
              <van-search v-model="deptUserTreeAll.filterText" @input="treeSearch($event, $refs.tree)" clearable shape="round"/>
              <div style="overflow-y: auto" class="h-vh-50">
                <div class="p-10">
                  <el-tree ref="tree" @check-change="singleChoice($event,$refs.tree)" node-key="uuid" check-strictly :data="deptUserTreeAll.data" :filter-node-method="filterNode" check-on-click-node show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>

        <van-field v-f-show="'xmwcrq'" v-model="formData.xmwcrq" :required="isRequired('xmwcrq')" name="xmwcrq" label="项目完成日期" placeholder="项目完成日期" input-align="right" :rules="getRules('xmwcrq')">
          <template #input>
            <view-item @click.native="isShowPopup(xmwcrq,'xmwcrq')" :value="formData.xmwcrq" placeholder="请选择项目完成日期"/>
            <van-calendar v-model="xmwcrq.show" ref="xmwcrq" :show-confirm="false" title="选择项目完成日期" @confirm="xmwcrqConfirm"></van-calendar>
          </template>
        </van-field>

        <van-field v-f-show="'sszpm'" v-model="formData.sszpm" :readonly="isDisabled('sszpm')" type="number" :required="isRequired('sszpm')" :rules="getRules('sszpm')" name="sszpm" maxlength="50" autosize label="实施总平米数(㎡)" placeholder="请输入实施总平米数" input-align="right"/>
        <van-field v-f-show="'xmszdq'" v-model="formData.xmszdq" :readonly="isDisabled('xmszdq')" :required="isRequired('xmszdq')" name="xmszdq" :rules="getRules('xmszdq')" type="textarea" maxlength="200" rows="3" autosize label="项目所在地区" show-word-limit placeholder="请输入项目所在地区" input-align="right"/>
        <van-field v-f-show="'shjlfj'" class="fileValueBox" :value.prop="formData.shjlfj" input-align="right" name="shjlfj" :required="isRequired('shjlfj')" label="上传审核记录表" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('shjlfj')" :files="formData.shjlfj"
            @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','shjlfj')"
             @success="(fileList) => {uploadSuccess(fileList,'shjlfj')}" module-type="flow"></uploadFiles>
          </template>
        </van-field>
        <van-field v-f-show="'yjcfbfj'" class="fileValueBox" :value.prop="formData.yjcfbfj" input-align="right" name="yjcfbfj" :required="isRequired('yjcfbfj')" label="业绩拆分电子表" placeholder="请上传业绩拆分电子表">
          <template #input>
            <uploadFiles :disabled="isDisabled('yjcfbfj')" :files="formData.yjcfbfj" 
             @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','yjcfbfj')"
            @success="(fileList) => {uploadSuccess(fileList,'yjcfbfj')}" module-type="flow"></uploadFiles>
          </template>
        </van-field>
      </van-cell-group>
    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20" :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false" @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable shape="round"/>
      <div style="overflow-y: auto" class="h-vh-50">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>

import {defineComponent} from "vue";
import {getFormDataByInstanceId} from "@/api/flow";
import cache from "@/plugins/cache";
import mixin from '@/mixin/flow'
import {getDeptUserTreeAll, selectMyProjectList} from "@/api/user";
import moment from "moment/moment";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";

export default defineComponent({
  components: {uploadFiles, approver, flowTrace, bottomBar},
  mixins: [mixin,fileMixins],
  data() {
    return {
      formData: {
        ssdwmc: '',
        ssxm: '',
        xmfzr: [],
        xmwcrq: '',
        sszpm: '',
        xmszdq: '',
        shjlfj: [],
        yjcfbfj: [],
      },
      rules: {},
      // 项目完成日期
      xmwcrq: {
        show: false,
      },
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
    }
  },
  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.formData.ssbm = currentUserInfo.dept.deptName
      this.selectMyProjectList(currentUserInfo)
    }
  },
  methods: {
    // 进页面就调用
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
    },
    // 订餐人弹窗
    handlePopupSubmit() {
      if (this.$refs.tree.getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一人', position: 'bottom'})
        return
      }
      this.$set(this.formData, 'xmfzr', this.$refs.tree.getCheckedNodes())
      this.deptUserTreeAll.show = false
    },
    uploadSuccess(fileList, field) { // 每次都会filelist全部丢出来
      this.formData[field] = fileList
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
    xmwcrqConfirm(date) {
      this.formData.xmwcrq = moment(date).format('YYYY-MM-DD')
      this.xmwcrq.show = false
    },
    // 获取人员所属项目列表
    selectMyProjectList(user, more) {
      this.btnLoading = true
      return new Promise(resolve => {
        selectMyProjectList({projectMember: user.id || user.userId, more}).then(res => {
          this.btnLoading = false
          this.ssxm.data = res.rows
          this.ssxm.filteredData = res.rows
          resolve(res.rows)
        })
      })
    },
  }
})
</script>
<style scoped lang="less">

</style>